import { io } from "socket.io-client"
import { IMAGE_URL } from "../config"

let socket = null

export function getLiveSocket() {
  if (socket) return socket
  const url = IMAGE_URL
  if (!url) return null
  socket = io(url, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 1000,
    timeout: 10000,
  })
  return socket
}
